/**
 * Freeform ajax submissions and validation
 */

import Bouncer from "formbouncerjs";
import Mustache from "mustache";

let Forms = (function() {

    'use strict';

    /*
     * Start with init Function
     */
    function init(el) {

        let form = null;
        let formWrapper = document.querySelector(el);
        if (formWrapper) {
            form = formWrapper.querySelector('form');
        }

        if (form) {

            let templateError = `
                <div class="c-form__message error">
                     <div class="c-form__message-icon">
                         <svg aria-hidden="true" role="img" focusable="false">
                            <use xlink:href="#icon-exclamation-triangle"></use>
                         </svg>
                    </div>
                    <ul class="c-form__message-text">
                        {{#errors}}
                            <li>{{message}}</li>
                        {{/errors}}
                    </ul>
                </div> 
            `;

            let templateSuccess = `
                <div class="c-form__message success">
                    <div class="c-form__message-icon">
                        <svg aria-hidden="true" role="img" focusable="false">
                            <use xlink:href="#icon-check-circle"></use>
                        </svg>
                    </div>
                    <p class="c-form__message-text">Thank you, your message was sent successfully.</p>
                </div>
            `;

            // make privacy_consent checkbox required
            let privacyCheckbox = formWrapper.querySelector('input[name="legalConsent"][type="checkbox"]');
            if (privacyCheckbox) {
                privacyCheckbox.setAttribute('required', 'required');
            }

            // init validation
            let validate = new Bouncer(el + ' form', {
                disableSubmit: true,
                emitEvents: true
            });

            // form submitted, client-side validation failed
            formWrapper.addEventListener('bouncerFormInvalid', function (e) {
                //console.log('bouncerFormInvalid');
            });

            // refresh form tokens, if static cached
            let formHandle = formWrapper.dataset.form;

            if (formHandle) {
                let firstInput = formWrapper.querySelectorAll('input[type=text][required]')[0];
                if (firstInput) {
                    firstInput.addEventListener('focus', (e) => {

                        // prevent this being called again
                        if (e.currentTarget.dataset.triggered) {
                            return;
                        }
                        e.currentTarget.dataset.triggered = true;

                        // refresh tokens
                        let focusedForm = getClosest(e.target, 'form');

                        let request = new XMLHttpRequest();
                        request.onload = function () {
                            let data = JSON.parse(request.response);
                            focusedForm.querySelector('input[name=formHash]').value = data.hash;

                            // Locate and update the CSRF input
                            let csrf = data.csrf;
                            focusedForm.querySelector('input[name=' + csrf.name + ']').value = csrf.value;
                        };

                        request.open("GET", '/dynamic/form-tokens?form='+formHandle);
                        request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
                        request.setRequestHeader("HTTP_X_REQUESTED_WITH", "XMLHttpRequest");
                        request.send();
                    });
                }
            }

            // form submitted, client-side validation passed
            formWrapper.addEventListener('bouncerFormValid', function (e) {

                e.preventDefault();

                let form = e.target;
                let data = new FormData(form);
                let request = new XMLHttpRequest();
                let formFieldset = form.querySelector('.js-form-fieldset');
                let formMessages = form.querySelector('.js-form-messages');
                let formsubmitDisabledClass = 'is-disabled';

                // disable submit button
                let submitBtn = form.querySelector('button[type="submit"]');
                let submitBtnValue = 'Submit';
                if (submitBtn) {
                    submitBtnValue = submitBtn.innerHTML; // make a record of original value
                    //submitBtn.setAttribute('disabled', true);
                    submitBtn.innerHTML = 'Sending…';
                    submitBtn.classList.add(formsubmitDisabledClass);
                }

                request.onload = function () {

                    // response data is returned as a string
                    let data = JSON.parse(request.response);

                    //console.log(data);

                    // All reported errors
                    let formErrors = [];

                    // Process our return data
                    if (request.status >= 200 && request.status < 300) {

                        // Did form validation succeed or are there errors?
                        if (data.success && data.finished) {
                            // server-side validation passed
                            //console.log('server-side validation passed');
                            let successMessage = Mustache.render(templateSuccess);
                            formFieldset.innerHTML = successMessage;

                            return;

                        } else {

                            // server-side validation failed
                            //console.log('server-side validation failed');

                            // form hash, honeypot errors
                            if (data.formErrors.length > 0) {
                                for (let i=0; i < data.formErrors.length; i++) {
                                    formErrors.push({"message" : data.formErrors[i]});
                                }
                            }

                            // form field errors
                            if (data.errors) {

                                Object.keys(data.errors).map(function(field, index) {

                                    let errorMessage = data.errors[field];
                                    let error;

                                    // prepend the form label to the error message, if it exists
                                    let fieldElm = form.querySelector(['[name="' + field + '"][id]']);

                                    if (fieldElm) {
                                        let fieldElmId = fieldElm.getAttribute('id');

                                        let fieldLabel = form.querySelector('label[for="'+fieldElmId+'"]');

                                        //console.log(fieldElmId);

                                        if (fieldLabel) {
                                            let fieldLabelText = fieldLabel.textContent;

                                            if (fieldLabelText) {
                                                field = fieldLabelText;
                                            }

                                            error = field + ': ' + errorMessage;
                                        }
                                    } else {
                                        error = errorMessage;
                                    }

                                    formErrors.push({"message" : error});

                                });
                            }

                            // unknown error
                            if (formErrors.length === 0) {
                                formErrors.push({"message" : 'Sorry, the form could not be validated'});
                            }

                        }

                    } else {
                        formErrors.push({"message" : 'Sorry, the form could not be sent at this time'});
                    }

                    // If we've got this far, render errors above the form
                    if (formErrors.length > 0) {
                        formMessages.innerHTML = Mustache.render(templateError, {'errors' : formErrors});

                        // restore submit button
                        submitBtn = form.querySelector('button[type="submit"]');
                        if (submitBtn) {
                            //submitBtn.setAttribute('disabled', false);
                            submitBtn.innerHTML = submitBtnValue;
                            submitBtn.classList.remove(formsubmitDisabledClass);
                        }

                        // add the new honeypot
                        if (data.honeypot) {
                            let honeypotHTML = '<input type="hidden" value="'+data.honeypot.hash+'" name="'+data.honeypot.name+'" id="'+data.honeypot.name+'">';
                            let honeypotDiv = document.createElement('div');
                            honeypotDiv.innerHTML = honeypotHTML;
                            formFieldset.appendChild(honeypotDiv);
                        }
                    }
                };

                request.open("POST", '');
                request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
                request.setRequestHeader("HTTP_X_REQUESTED_WITH", "XMLHttpRequest");
                request.send(data);
            }, {
                once: false
            });
        }
    }

    function getClosest(elem, selector) {

        // Element.matches() polyfill
        if (!Element.prototype.matches) {
            Element.prototype.matches =
                Element.prototype.matchesSelector ||
                Element.prototype.mozMatchesSelector ||
                Element.prototype.msMatchesSelector ||
                Element.prototype.oMatchesSelector ||
                Element.prototype.webkitMatchesSelector ||
                function(s) {
                    var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                        i = matches.length;
                    while (--i >= 0 && matches.item(i) !== this) {}
                    return i > -1;
                };
        }

        // Get the closest matching element
        for ( ; elem && elem !== document; elem = elem.parentNode ) {
            if ( elem.matches( selector ) ) return elem;
        }
        return null;

    }

    return {
        init: init
    };

})();

export default Forms;